import { render, staticRenderFns } from "./knowledge_page.vue?vue&type=template&id=6f9a481e&scoped=true&"
import script from "./knowledge_page.vue?vue&type=script&lang=js&"
export * from "./knowledge_page.vue?vue&type=script&lang=js&"
import style0 from "./knowledge_page.vue?vue&type=style&index=0&id=6f9a481e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9a481e",
  null
  
)

export default component.exports